import React from 'react'
import cn from 'classnames'

import st from './index.scss'

export default function Button({ className, type, children, size, active, ...props }) {
    return <div className={cn(st['btn'], {
        [st[type]]: !!type,
        [st[size]]: !!size,
        [st['active']]: !!active
    }, className)} {...props}>
        {children}
    </div>
}
